<template>
  <div>
    <component nested :is="componentName" :question="{ issue: issue }" @change="onChangeValue" />
  </div>
</template>

<script>
import { componentMap, createIssueFactory } from 'dygc'
import TextFill from '@/questions/text-fill/TextFill'
import SingleSelectChoice from '@/questions/choice/SingleSelectChoice'
import MultipleSelectChoice from '@/questions/choice/MultipleSelectChoice'

export default {
  name: 'ComposeItem',
  components: { TextFill, SingleSelectChoice,MultipleSelectChoice },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    col: {
      type: Object,
      default: () => ({})
    },
    cell: {
      type: Object,
      default: () => ({})
    },
    cacheValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      issue: null
    }
  },
  computed: {
    componentName() {
      return componentMap.get(this.cell.cell_type)
    }
  },
  created() {
    let cell = this.cell
    this.issue = createIssueFactory(cell, cell.cell_type)
  },
  methods: {
    onChangeValue() {
      let value = this.issue.getValue()
      if (!value.length) {
        value = []
      }
      let rowId = this.row.row_id
      let colId = this.col.id
      value = value.map(val => {
        return Object.assign({}, val, { rowId, colId })
      })
      this.$emit('change', value)
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.cacheValue) {
        this.issue.setValue([this.cacheValue])
      }
    })
  }
}
</script>
